import { OAuthStrategyOptions } from './oauth-strategy.types';

type OAuthCache = {
  providers: Map<string, OAuthStrategyOptions>
  register: (provider: OAuthStrategyOptions) => OAuthStrategyOptions
  get: (providerId: string) => OAuthStrategyOptions
}

const Cache: OAuthCache = {
    providers: new Map(),
    register(provider) {
        this.providers.set(provider.id, provider);

        return provider;
    },
    get(providerId: string) {
        return this.providers.get(providerId);
    },
};

export default Cache;
